import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export class JobOfferForm {
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group(
      {
        idArea: ['', Validators.required],
        idDepartament: [null, Validators.required],
        idProvince: [{ value: null, disabled: true }, Validators.required],
        idDistrict: [{ value: null, disabled: true }, Validators.required],
        idJobType: ['', Validators.required],
        idEducation: ['', Validators.required],
        idProfession: ['', Validators.required],
        idJobTitle: ['', Validators.required],
        jobTitle: [
          '',
          [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(100),
          ],
        ],
        subTitle: [
          '',
          [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(150),
          ],
        ],
        description: ['', [Validators.required, Validators.minLength(10)]],
        minSalary: ['', [Validators.min(0), Validators.max(9999)]],
        maxSalary: ['', [Validators.min(0), Validators.max(9999)]],
        minAge: [
          18,
          [Validators.required, Validators.min(18), Validators.max(99)],
        ],
        maxAge: [
          40,
          [Validators.required, Validators.min(18), Validators.max(99)],
        ],
        experience: [
          1,
          [Validators.required, Validators.min(0), Validators.max(50)],
        ],
        numberVacancies: [
          1,
          [
            Validators.required,
            Validators.pattern(/^[1-9]\d*$/),
            Validators.max(99),
          ],
        ],
        showSalary: [true],
        hasRemuneration: [false],
      },
      {
        validators: [this.ageRangeValidator(), this.salaryRangeValidator()],
      }
    );
  }

  private ageRangeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const minAge = group.get('minAge')?.value;
      const maxAge = group.get('maxAge')?.value;
      return minAge && maxAge && minAge > maxAge
        ? { ageRangeInvalid: true }
        : null;
    };
  }

  private salaryRangeValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const minSalary = group.get('minSalary')?.value;
      const maxSalary = group.get('maxSalary')?.value;
      return minSalary && maxSalary && minSalary > maxSalary
        ? { salaryRangeInvalid: true }
        : null;
    };
  }

  get idArea() {
    return this.form.get('idArea');
  }
  get idDistrict() {
    return this.form.get('idDistrict');
  }
  get idProvince() {
    return this.form.get('idProvince');
  }
  get idDepartament() {
    return this.form.get('idDepartament');
  }
  get idJobType() {
    return this.form.get('idJobType');
  }
  get idProfession() {
    return this.form.get('idProfession');
  }
  get idJobTitle() {
    return this.form.get('idJobTitle');
  }
  get jobTitle() {
    return this.form.get('jobTitle');
  }
  get subTitle() {
    return this.form.get('subTitle');
  }
  get description() {
    return this.form.get('description');
  }
  get minSalary() {
    return this.form.get('minSalary');
  }
  get maxSalary() {
    return this.form.get('maxSalary');
  }
  get minAge() {
    return this.form.get('minAge');
  }
  get maxAge() {
    return this.form.get('maxAge');
  }
  get experience() {
    return this.form.get('experience');
  }
  get numberVacancies() {
    return this.form.get('numberVacancies');
  }
  get showSalary() {
    return this.form.get('showSalary');
  }
  get hasRemuneration() {
    return this.form.get('hasRemuneration');
  }
}
